import * as Phaser from 'phaser';
import b64toBlob from '../../../../../../utils/b64toBlob';
import { Observer, GLOBAL_EVENT } from '../../../../Observer';
import generateId from '../../../../../../utils/generateId';
import store from '../../../../../../Redux/Store/store';
import { AddImage, ImageData } from '../../../../../../Redux/Actions/Atlas/images.action';

// TODO: Mandar calculateGrid a utils/
const calculateGrid = (
    grid_options: { width: number; height: number; space: number },
    canvas: { width: number; height: number }
) => {
    let actual_position = {
        x: Math.floor(canvas.width / grid_options.width),
        y: Math.floor(canvas.height / grid_options.height),
    };
    if (grid_options.space > 1) {
        const x = Math.floor(
            canvas.width /
                (((actual_position.x + 1) * grid_options.space) / actual_position.x +
                    grid_options.width)
        );
        const y = Math.floor(
            canvas.height /
                (((actual_position.y + 1) * grid_options.space) / actual_position.y +
                    grid_options.height)
        );
        actual_position = { x, y };
    }
    return actual_position;
};

class ImportAtlasRenderScene extends Phaser.Scene {
    // Nos ayuda a obtener el tamaño original
    canvas_size = {
        width: 0,
        height: 0,
    };

    name: string = 'imagen_defecto';
    // Sistema de grid
    graphics: any;
    lineStrike = 2;
    grid_width = 10;
    grid_height = 10;
    space = 0;

    zoom_scale = 1;
    block: any;

    constructor() {
        super({ key: 'ImportAtlasRenderScene' });
        Observer.removeListener(GLOBAL_EVENT.IMPORT_ATLAS.CHANGE_IMPORT_ATLAS_STATE);
        Observer.removeListener(GLOBAL_EVENT.IMPORT_ATLAS.IMPORT_ATLAS_GRID_BUTTON);
    }

    init() {
        this.graphics = this.add
            .graphics({ lineStyle: { width: 2, color: 0xffffff }, fillStyle: { color: 0xaa0000 } })
            .setDepth(200);
        Observer.on(GLOBAL_EVENT.IMPORT_ATLAS.CHANGE_IMPORT_ATLAS_STATE, (options) => {
            if (options.width !== this.grid_width) {
                this.grid_width = options.width;
            }
            if (options.height !== this.grid_height) {
                this.grid_height = options.height;
            }
            if (options.separation !== this.space) {
                this.space = options.separation;
            }
            if (options.zoom !== this.zoom_scale) {
                this.zoom_scale = options.zoom / 100;
                this.setZoom();
            }
            this.createGrid();
        });

        Observer.on(GLOBAL_EVENT.IMPORT_ATLAS.IMPORT_ATLAS_GRID_BUTTON, () => {
            this.cutSprites();
        });

        Observer.on(GLOBAL_EVENT.IMPORT_ATLAS.IMPORT_ATLAS_JSON, (atlas_json) => {
            this.cutSprites(atlas_json);
        });

        // Evento interno para enviar el nombre
        this.events.on('set_name', (name: string) => {
            this.name = name;
        });

        this.load.once(Phaser.Loader.Events.COMPLETE, () => {
            this.load_complete();
        });
    }

    load_complete() {
        this.block = this.add.image(0, 0, this.name).setScale(this.zoom_scale).setOrigin(0);

        this.scale.setGameSize(
            this.block.width * this.zoom_scale,
            this.block.height * this.zoom_scale
        );
        this.canvas_size.width = this.block.width;
        this.canvas_size.height = this.block.height;

        this.createGrid();
    }

    resetZoom() {
        this.block.setScale(1);
        this.scale.setGameSize(this.canvas_size.width, this.canvas_size.height);
    }

    setZoom() {
        this.block.setScale(this.zoom_scale);
        this.scale.setGameSize(
            this.block.width * this.zoom_scale,
            this.block.height * this.zoom_scale
        );
        this.createGrid();
    }

    createGrid() {
        const grid_width = this.grid_width * this.zoom_scale;
        const grid_height = this.grid_height * this.zoom_scale;

        const space = this.space * this.zoom_scale;
        const grid = calculateGrid(
            { width: this.grid_width, height: this.grid_height, space: this.space },
            this.canvas_size
        );
        // Construimos el grid
        this.graphics.clear();
        this.graphics.lineStyle(this.lineStrike, 0xffffff);
        for (let y = 0; y < grid.y; y++) {
            for (let x = 0; x < grid.x; x++) {
                const pos_x = x * grid_width + space * (x + 1);
                const pos_y = y * grid_height + space * (y + 1);
                const rect = new Phaser.Geom.Rectangle(pos_x, pos_y, grid_width, grid_height);

                this.graphics.strokeRectShape(rect);
            }
        }
    }

    cutSprites(atlas_json = 'no_atlas') {
        const grid = calculateGrid(
            { width: this.grid_width, height: this.grid_height, space: this.space },
            this.canvas_size
        );

        if (grid.x * grid.y > 1000 && atlas_json === 'no_atlas') {
            // Esto no es un atlas
            Observer.emit(
                GLOBAL_EVENT.NOTIFICATION_SYSTEM.WARNING,
                `The limit of frames is 1000 you are superate it in ${
                    grid.x * grid.y
                } (width * height),  reduce it.`
            );
        } else {
            Observer.emit(GLOBAL_EVENT.NOTIFICATION_SYSTEM.CLEAR);
            this.graphics.clear();
            // Acá recibimos la data de la imagen
            this.load.once(Phaser.Loader.Events.COMPLETE, () => {
                const texturesKeys = Object.keys(
                    this.textures.get(`${this.name}_spritesheet`).frames
                ).filter((key: string) => key !== '__BASE');
                const ImagesData: ImageData[] = texturesKeys.map(
                    (key: any, i: number): ImageData => {
                        const frame = this.textures.getFrame(`${this.name}_spritesheet`, key);
                        const src_b64 = this.textures.getBase64(`${this.name}_spritesheet`, key);
                        return {
                            id: generateId(),
                            name: atlas_json === 'no_atlas' ? `${this.name}_${i}` : frame.name,
                            width: frame.width,
                            height: frame.height,
                            size: 0,
                            active: false,
                            changeName: false,
                            src: src_b64,
                            origin: {
                                x: 0.5,
                                y: 0.5,
                            },
                        };
                    }
                );

                Observer.emit(GLOBAL_EVENT.IMPORT_ATLAS.CLOSE_ATLAS_IMPORT);
                store.dispatch(AddImage(ImagesData));
            });

            this.resetZoom();
            this.graphics.setDepth(-1);

            // Se monta la imagen y más arriba se recibe esta imagen
            this.game.renderer.snapshot((image: any) => {
                if (atlas_json !== 'no_atlas') {
                    this.load.atlas(
                        `${this.name}_spritesheet`,
                        URL.createObjectURL(b64toBlob(image.src)),
                        JSON.parse(atlas_json)
                    );
                } else {
                    this.load.spritesheet(
                        `${this.name}_spritesheet`,
                        URL.createObjectURL(b64toBlob(image.src)),
                        {
                            frameWidth: this.grid_width,
                            frameHeight: this.grid_height,
                            margin: this.space,
                            spacing: this.space,
                        }
                    );
                }
                this.load.start();
            });
        }
    }
}

export default ImportAtlasRenderScene;
